import React from 'react'
import Image from '../Image';

const ProductDetail = ({colors, description,handleOnChange, images, price, sizes, title}) => {
  
  return (
    <section className="pt-80 pb-160 pt-sm-50 pb-sm-50">
        <div className="container-3">
            <div className="row">
                <div className="col-sm-12 col-md-6 col-lg-6 col-xl-5">
                    <div className="mt-40">
                        <div id="sync1" className="owl-carousel owl-theme big-product-carousel">
                        {
                          images.map((image, i)=> (
                            <div className="item" key={i}>
                              <Image className="img-fluid center-block" image={image}/>
                            </div>
                          ))
                        }</div>
                        <div id="sync2" className="owl-carousel owl-theme thumb-product-carousel">
                        {
                          images.map((image, i)=>(
                            <div className="item" key={i}>
                              <Image className="img-fluid center-block" image={image}/>
                              </div>
                          ))
                        } </div>
                    </div>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    <div className="product-detail mt-40">
                        <p className="product-category">Pots</p>
                        <h1>{title}</h1>
                        <div className="product-description">
                            <p>{description}</p>
                        </div>
                        <p className="price">{price}</p>
                        <form className="product-customize"><div className="form-group">
                                <select className="custom-select">
                                {
                                  colors.map((color, i)=>(
                                    <option key={i} value={i}>{color}</option>
                                  ))
                                }
                                </select>
                            </div>
                            <div className="form-group">
                                <select className="custom-select">
                                {
                                  sizes.map((size, i)=>(
                                    <option key={i} value={i}>{size}</option>
                                  ))
                                }
                                </select>
                            </div>
                            <div className="form-group">
                                <div className="clearfix input-qty">
                                    <span>-</span>
                                    <input type="text" onChange={handleOnChange} className="form-control" value="1"/>
                                    <span>+</span>
                                </div>
                            </div>
                            <div className="form-group mt-50 mb-0">
                                <button type="submit" className="btn btn btn-grey-border btn-block center-block text-uppercase">Add to cart</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}

export default ProductDetail;